import { render, staticRenderFns } from "./CustomerVerifications.vue?vue&type=template&id=77c2bae0&lang=html&"
import script from "./CustomerVerifications.vue?vue&type=script&lang=js&"
export * from "./CustomerVerifications.vue?vue&type=script&lang=js&"
import style0 from "./CustomerVerifications.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports